var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarranty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13_1326",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13_1326)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 11.8333C11.2162 11.8333 9.5 13.5495 9.5 15.6666V52.9999C9.5 55.117 11.2162 56.8333 13.3333 56.8333H50.6667C52.7838 56.8333 54.5 55.117 54.5 52.9999V15.6666C54.5 13.5495 52.7838 11.8333 50.6667 11.8333H13.3333ZM6.5 15.6666C6.5 11.8926 9.55939 8.83325 13.3333 8.83325H50.6667C54.4406 8.83325 57.5 11.8926 57.5 15.6666V52.9999C57.5 56.7739 54.4406 59.8333 50.6667 59.8333H13.3333C9.55939 59.8333 6.5 56.7739 6.5 52.9999V15.6666Z",
    fill: "#11216C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.6665 3.5C43.4949 3.5 44.1665 4.17157 44.1665 5V15.6667C44.1665 16.4951 43.4949 17.1667 42.6665 17.1667C41.8381 17.1667 41.1665 16.4951 41.1665 15.6667V5C41.1665 4.17157 41.8381 3.5 42.6665 3.5Z",
    fill: "#11216C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3335 3.5C22.1619 3.5 22.8335 4.17157 22.8335 5V15.6667C22.8335 16.4951 22.1619 17.1667 21.3335 17.1667C20.5051 17.1667 19.8335 16.4951 19.8335 15.6667V5C19.8335 4.17157 20.5051 3.5 21.3335 3.5Z",
    fill: "#11216C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 26.333C6.5 25.5046 7.17157 24.833 8 24.833H56C56.8284 24.833 57.5 25.5046 57.5 26.333C57.5 27.1614 56.8284 27.833 56 27.833H8C7.17157 27.833 6.5 27.1614 6.5 26.333Z",
    fill: "#11216C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarranty);
export default __webpack_public_path__ + "static/media/warranty.2b033a362fa9d9f6fefc0b79ae3ca856.svg";
export { ForwardRef as ReactComponent };